import {useABTest} from "@pg-mono/ab-testing";

import {MULTILEAD_TINDER_VARIANT, multileadTinderAbTests} from "../multilead_tinder_ab_tests";

export function useMultileadTinderAbTest() {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: multileadTinderAbTests.id,
        variants: multileadTinderAbTests.variants,
        withSSR: multileadTinderAbTests.withSSR
    });

    return {
        isMultileadTinderEnabled: canABTestBeRendered && abTestVariant === MULTILEAD_TINDER_VARIANT
    };
}
import {useABTest} from "@pg-mono/ab-testing";

import {MULTILEAD_TINDER_VARIANT, multileadTinderAbTests} from "../multilead_tinder_ab_tests";

export function useMultileadTinderAbTest() {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: multileadTinderAbTests.id,
        variants: multileadTinderAbTests.variants,
        withSSR: multileadTinderAbTests.withSSR
    });

    return {
        isMultileadTinderEnabled: canABTestBeRendered && abTestVariant === MULTILEAD_TINDER_VARIANT
    };
}
